export default __webpack_public_path__ + "static/media/step1.e97f015a.jpg";